import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";

// CONFIGURAZIONE DATI: Incolla qui i tuoi link Imgur
const DATA = {
  titoli: [
    {
      id: "maturita",
      prefix: "● ",
      label: "Diploma di Maturità (clicca per visualizzare)", // La parte viola cliccabile
      suffix: ' presso l\'Istituto "Giovanni Gentile" con valutazione 100/100.',
      img: "https://i.imgur.com/avZ4pIl.png"
    },
    {
      id: "astro",
      prefix: "● Laurea in ",
      label: "Astrofisica (clicca per visualizzare)",
      suffix: ' presso l\'Università "Santa Helenie" con valutazione 76/110.',
      img: "https://i.imgur.com/AXvbYp7.png"
    },
    {
      id: "info",
      prefix: "● Laurea in ",
      label: "Informatica (clicca per visualizzare)",
      suffix: ' presso l\'Università "Santa Helenie" con valutazione 110/110 e Lode.',
      img: "https://i.imgur.com/jsmhbr4.png"
    },
    {
      id: "cultore",
      prefix: "● ",
      label: "Cultore per Titolo (clicca per visualizzare)",
      suffix: " della facoltà di Informatica.",
      img: "https://i.imgur.com/dsCwWad.png"
    },
  ],
  attestati: [
    { id: "med", prefix: "● Attestato di ", label: "Medicina (clicca per visualizzare)", suffix: ' presso l\'Istituto "Giovanni Gentile".', img: "https://i.imgur.com/xcIs3gR.png" },
    { id: "giuri", prefix: "● Attestato di ", label: "Giurisprudenza (clicca per visualizzare)", suffix: ' presso l\'Istituto "Giovanni Gentile".', img: "https://i.imgur.com/YW0r5ml.png" },
    { id: "eco", prefix: "● Attestato di ", label: "Economia (clicca per visualizzare)", suffix: ' presso l\'Istituto "Giovanni Gentile".', img: "https://i.imgur.com/Wcrg35z.png" },
    { id: "pol", prefix: "● Attestato di ", label: "Scienze Politiche (clicca per visualizzare)", suffix: ' presso l\'Istituto "Giovanni Gentile".', img: "https://i.imgur.com/Lr5fCwU.png" },
    { id: "form", prefix: "● Attestato di ", label: "Scienze della Formazione (clicca per visualizzare)", suffix: ' presso l\'Istituto "Giovanni Gentile".', img: "https://i.imgur.com/ifqOAUx.png" },
    { id: "eng", prefix: "● Attestato di ", label: "Cambridge livello C2 (clicca per visualizzare)", suffix: ' presso l\'Istituto "Giovanni Gentile".', img: "https://i.imgur.com/jie5vNw.png" },
  ]
};

function Istruzione() {
  const [activeId, setActiveId] = useState(null);

  const toggle = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  // Funzione che renderizza SOLO le parti interattive (Titoli e Attestati)
  const renderInteractiveItem = (item) => {
    const isOpen = activeId === item.id;

    return (
      <div key={item.id} style={{ marginBottom: "5px" }}>
        {/* TESTO (Visibile se chiuso) */}
        {!isOpen && (
          <p style={{ textAlign: "left", margin: 0 }}>
            {item.prefix}
            <span
              className="purple"
              onClick={() => toggle(item.id)}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold"
              }}
              title="Clicca per visualizzare"
            >
              {item.label}
            </span>
            {item.suffix}
          </p>
        )}

        {/* IMMAGINE (Visibile se aperto) */}
        {isOpen && (
          <div
            onClick={() => toggle(item.id)}
            style={{ 
              cursor: "pointer", 
              textAlign: "center", 
              animation: "fadeIn 0.5s", 
              padding: "10px 0" 
            }}
          >
            <img
              src={item.img}
              alt={item.label}
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.5)"
              }}
            />
            <div style={{ fontSize: "0.8rem", color: "#ccc", marginTop: "5px" }}>
              (Clicca l'immagine per chiudere)
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col md={10}>
        <blockquote className="blockquote mb-0">
          
          {/* --- TITOLI DI STUDIO (Interattivi) --- */}
          <h2 style={{ fontSize: "1.5em", align: "center", color: "#C770F0" }}>Titoli di Studio <img 
                  src="https://i.imgur.com/X1EHP04.gif" 
                  style={{ height: "50px"}} 
                />  </h2>
          <div style={{ marginBottom: "30px" }}>
            {DATA.titoli.map(item => renderInteractiveItem(item))}
          </div>

          {/* --- ATTESTATI (Interattivi) --- */}
          <h2 style={{ fontSize: "1.5em", align: "center", color: "#C770F0" }}>Attestati <img 
                  src="https://i.imgur.com/wu8tLjx.png" 
                  style={{ height: "50px"}} 
                /></h2>
          <div style={{ marginBottom: "30px" }}>
            {DATA.attestati.map(item => renderInteractiveItem(item))}
          </div>

          {/* --- SEMINARI (Statici - Nessuna immagine) --- */}
          {/* Qui ho rimesso il tuo codice HTML statico originale */}
          <h2 style={{ fontSize: "1.5em", align: "center", color: "#C770F0"  }}>Seminari Accademici (AAF)</h2>
           <p style={{ textAlign: "left" }}>
            ● <span className="purple">Steve Jobs e la nascita di Apple</span>, svolto dal 03/06/2024 al 10/06/2024, testo accademico disponibile presso il Giornalaio dal 09/04/2024.<br />
            ● <span className="purple">Le Cryptovalute</span>, svolto dal 26/03/2025 al 31/03/2025, testo accademico disponibile presso il Giornalaio dal 17/05/2025.
          </p>

        </blockquote>
      </Col>
    </Row>
  );
}


export default Istruzione;